/* Inasense Co theme behavior — no dependencies. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header height var + solid state */
  var hdr = document.querySelector('.ina .hdr');
  function hdrH() {
    if (hdr) document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
  }
  hdrH();
  window.addEventListener('resize', hdrH);

  var sticky = document.querySelector('.ina .sticky');
  function onScroll() {
    var y = window.scrollY || 0;
    if (hdr) hdr.classList.toggle('solid', y > 40);
    if (sticky) sticky.classList.toggle('on', y > window.innerHeight * 0.9);
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* mobile nav */
  var burger = document.querySelector('.ina .burger');
  var nav = document.querySelector('.ina .nav');
  if (burger && nav) burger.addEventListener('click', function () {
    nav.classList.toggle('nav--open');
    burger.setAttribute('aria-expanded', nav.classList.contains('nav--open') ? 'true' : 'false');
  });

  /* staggered reveals */
  var rv = [].slice.call(document.querySelectorAll('.ina .rv'));
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = +(e.target.getAttribute('data-d') || 0);
        setTimeout(function () { e.target.classList.add('in'); }, i * 90);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('in'); });
  }

  /* signature moment: scroll-scrubbed horizontal rail */
  var pin = document.querySelector('.ina .strip__pin');
  var rail = document.querySelector('.ina .strip__rail');
  var prog = document.querySelector('.ina .strip__prog i');
  if (pin && rail && window.innerWidth > 820 && !reduce) {
    var maxShift = 0;
    var measure = function () {
      maxShift = Math.max(0, rail.scrollWidth - window.innerWidth + parseFloat(getComputedStyle(rail).paddingLeft) * 2);
    };
    measure();
    window.addEventListener('resize', function () { measure(); tick(); });
    var raf = null;
    var tick = function () {
      var r = pin.getBoundingClientRect();
      var total = pin.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      rail.style.transform = 'translate3d(' + (-p * maxShift).toFixed(1) + 'px,0,0)';
      if (prog) prog.style.width = (p * 100).toFixed(1) + '%';
      raf = null;
    };
    window.addEventListener('scroll', function () {
      if (raf === null) raf = requestAnimationFrame(tick);
    }, { passive: true });
    tick();
  }

  /* lazy-start videos only while visible */
  var vids = [].slice.call(document.querySelectorAll('.ina video[data-auto]'));
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else if (!v.hasAttribute('data-keep')) { v.pause(); }
      });
    }, { threshold: 0.12 });
    vids.forEach(function (v) { vio.observe(v); });
  }

  /* cart count */
  function setCount(n) {
    [].slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (el) {
      el.textContent = n;
    });
  }

  /* real quick add — any [data-add][data-variant-id] */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var vid = b.getAttribute('data-variant-id');
    if (!vid) return;
    var t = b.textContent;
    b.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(vid), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add'); });
      return fetch('/cart.js').then(function (r2) { return r2.json(); });
    }).then(function (cart) {
      setCount(cart.item_count);
      b.textContent = 'Added';
      setTimeout(function () { b.textContent = t; }, 1600);
    }).catch(function (err) {
      b.textContent = t;
      var errEl = b.closest('.pdp__buy') && b.closest('.pdp__buy').querySelector('.pdp__err');
      if (errEl) { errEl.textContent = err.message; errEl.classList.add('on'); }
      else { b.textContent = 'Unavailable'; setTimeout(function () { b.textContent = t; }, 1800); }
    });
  });

  /* PDP: bind variant selection to price + button */
  [].slice.call(document.querySelectorAll('.ina .pdp__buy')).forEach(function (buy) {
    var vars = buy.querySelector('.vars');
    var dataEl = buy.querySelector('[data-variants]');
    if (!vars || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var btn = buy.querySelector('[data-add]');
    var price = buy.querySelector('.pdp__price');
    var hidden = buy.querySelector('form [name="id"]');
    function apply(id) {
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      if (price) price.textContent = v.price_formatted + (v.unit_suffix || '');
      if (btn) {
        btn.setAttribute('data-variant-id', v.id);
        btn.textContent = v.available ? ('Add to cart — ' + v.price_formatted) : 'Sold out';
        btn.disabled = !v.available;
      }
      if (hidden) hidden.value = v.id;
    }
    vars.addEventListener('change', function () {
      var el = vars.querySelector('input:checked') || vars.querySelector('select');
      if (el && el.value) apply(el.value);
    });
    var init = vars.querySelector('input:checked') || vars.querySelector('select');
    if (init && init.value) apply(init.value);
  });
})();
